//#region src/mod_price_option_display_style.ts
var ModPriceOptionDisplayStyle = /* @__PURE__ */ function(ModPriceOptionDisplayStyle) {
	ModPriceOptionDisplayStyle["Row"] = "row";
	ModPriceOptionDisplayStyle["Column"] = "column";
	return ModPriceOptionDisplayStyle;
}(ModPriceOptionDisplayStyle || {});
//#endregion
export { ModPriceOptionDisplayStyle };

//# sourceMappingURL=mod_price_option_display_style.js.map